module.exports = __webpack_public_path__ + "img/3.7a8b9a79.jpg";